import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo-ai-caption-round.png'
import _imports_1 from '../../assets/img/icons/apple-store.svg'
import _imports_2 from '../../assets/img/icons/google-play.svg'


const _withScopeId = n => (_pushScopeId("data-v-49afa591"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar-wrapper d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-light",
  src: _imports_0,
  width: "60",
  alt: "Image"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-dark",
  src: _imports_0,
  width: "60",
  alt: "Image"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other-options d-flex align-items-center ms-auto d-lg-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "app-btn d-flex align-items-center justify-content-end" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://apps.apple.com/us/app/ai-caption-image-caption/id6475199122",
      class: "d-flex flex-column justify-content-center align-items-center rounded-circle"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: "Image"
      })
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://play.google.com/store/apps/details?id=com.cdev.ai_caption",
      class: "d-flex flex-column justify-content-center align-items-center rounded-circle"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        alt: "Image"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-toggler d-lg-none",
    "data-bs-toggle": "offcanvas",
    href: "#navbarOffcanvas",
    role: "button",
    "aria-controls": "navbarOffcanvas"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "burger-menu" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "top-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "middle-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "bottom-bar" })
    ])
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<nav id=\"navbar\" class=\"navbar\" data-v-49afa591><div class=\"navbar-collapse d-flex justify-content-center\" data-v-49afa591><ul class=\"navbar-nav md-none\" data-v-49afa591><li class=\"nav-item\" data-v-49afa591><a class=\"nav-link\" href=\"#hero-area\" data-v-49afa591>Home</a></li><li class=\"nav-item\" data-v-49afa591><a class=\"nav-link\" href=\"#about-area\" data-v-49afa591>About</a></li><li class=\"nav-item\" data-v-49afa591><a class=\"nav-link\" href=\"#feature-area\" data-v-49afa591>Features</a></li><li class=\"nav-item\" data-v-49afa591><a class=\"nav-link\" href=\"#download-area\" data-v-49afa591>Donwload</a></li><li class=\"nav-item\" data-v-49afa591><a class=\"nav-link\" href=\"#footer-area\" data-v-49afa591>Contact</a></li></ul></div></nav><div class=\"app-btn d-flex align-items-center justify-content-end ms-auto md-none\" data-v-49afa591><a href=\"https://apps.apple.com/us/app/ai-caption-image-caption/id6475199122\" target=\"_blank\" class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" data-v-49afa591><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-49afa591></a><a href=\"https://play.google.com/store/apps/details?id=com.cdev.ai_caption\" target=\"_blank\" class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" data-v-49afa591><img src=\"" + _imports_2 + "\" alt=\"Image\" data-v-49afa591></a></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    id: "navbar-wrap",
    class: _normalizeClass(['navbar-area', { sticky: _ctx.isSticky }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _hoisted_5,
        _hoisted_6
      ])
    ])
  ], 2))
}